export enum Platforms {
  Alcopa = 'alcopa',
  BCA = 'bca',
}
